import sharedEN from '@hex/calculators-shared/locales/en/shared.json';
import sharedFI from '@hex/calculators-shared/locales/fi/shared.json';
import i18n, { changeLanguage, type Resource } from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const setupI18n = async (defaultLanguage = 'fi') => {
  const ns = ['cost'];

  const supportedLngs =
    window.location.hostname.includes('syst-www') || process.env.NODE_ENV === 'development'
      ? ['en', 'fi']
      : [defaultLanguage];

  const resources: Resource = {};

  for (const lng of supportedLngs) {
    for (const namespace of ns) {
      const translation = await import(`./public/locales/${lng}/${namespace}.json`);
      resources[lng] = {
        ...resources[lng],
        [namespace]: translation.default,
        shared: lng === 'fi' ? sharedFI : sharedEN,
      };
    }
  }

  // if language is not supported - fallback to FI.
  i18n.on('languageChanged', (newLang: string) => {
    if (i18n.options.supportedLngs && !i18n.options.supportedLngs.includes(newLang) && newLang !== 'cimode') {
      changeLanguage(defaultLanguage);
    }
  });

  // eslint-disable-next-line import/no-named-as-default-member
  return i18n
    .use(initReactI18next)
    .use(Backend)
    .init({
      resources,
      debug: true,
      fallbackLng: defaultLanguage,
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      defaultNS: 'cost',
      supportedLngs,
      ns,
    });
};
